interface ProfileTitleProps {
    title?: string | JSX.Element;
}

const ProfileTitle: React.FC<ProfileTitleProps> = ({ title, children }) => {
    return <div className="profile-title">{title ?? children}</div>;
}

export default ProfileTitle;